// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z6Mo_","colBig":"styles_colBig__eCuEa","colSmall":"styles_colSmall__2cJfT","shopifyNameWrapper":"styles_shopifyNameWrapper__vQ9wU"};